var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "input-box" },
    [
      _vm.label !== undefined
        ? _c("label", { staticClass: "label-text" }, [
            _vm._v(_vm._s(_vm.label) + "\n    "),
            (_vm.label != null) & (_vm.hrefText != null)
              ? _c("a", { attrs: { href: _vm.href, target: "_blank" } }, [
                  _vm._v("#" + _vm._s(_vm.hrefText)),
                ])
              : _vm._e(),
          ])
        : _vm._e(),
      _vm._v(" "),
      _c("validation-provider", {
        ref: "validationInput",
        attrs: { name: "baseInputEditValidationProvider", rules: _vm.rules },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function (ref) {
              var errors = ref.errors
              var valid = ref.valid
              return [
                _c(
                  "div",
                  {
                    staticClass: "select-contain form-group mt-auto mb-auto",
                    class: errors.length > 0 ? "error" : "",
                    staticStyle: { width: "auto" },
                  },
                  [
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.displayModel,
                            expression: "displayModel",
                          },
                        ],
                        staticClass: "select-contain-select",
                        attrs: {
                          id: _vm.id,
                          type: "text",
                          placeholder: "",
                          title: _vm.label,
                        },
                        on: {
                          change: function ($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function (o) {
                                return o.selected
                              })
                              .map(function (o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.displayModel = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          },
                        },
                      },
                      _vm._l(_vm.optionList, function (option) {
                        return _c(
                          "option",
                          {
                            key: option[_vm.idKey],
                            domProps: { value: option[_vm.idKey] },
                          },
                          [_vm._v(_vm._s(_vm.getOptionText(option)))]
                        )
                      }),
                      0
                    ),
                    _vm._v(" "),
                    _c("small", { staticClass: "error-text" }, [
                      _vm._v(_vm._s(errors[0])),
                    ]),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }